// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3z65O","head":"Table_head__3csDC","col":"Table_col__3K8b7"};